import {Injectable} from '@angular/core';
import {ArchivedProposal} from '@emma-labs/shared/typescript';
import {first, mergeMap, Observable} from 'rxjs';
import {RevisionAnswers} from '../../entities/archived-proposal-object/revision-answers';
import {AuthService} from '../auth.service';
import {ArchivedProposalApiService} from './archived-proposal-api.service';

@Injectable({
  providedIn: 'root',
})
export class ArchivedProposalService {
  constructor(
    private readonly api: ArchivedProposalApiService,
    private readonly authService: AuthService,
  ) {}

  get(archivedProposalId: string): Observable<ArchivedProposal> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) => this.api.getById(session.id, archivedProposalId)),
    );
  }

  answerHealthAnswersRevisions(
    archivedProposalId: string,
    revisionsAnswers: RevisionAnswers[],
  ): Observable<ArchivedProposal> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) =>
        this.api.answerHealthAnswersRevisions(session.id, archivedProposalId, revisionsAnswers),
      ),
    );
  }

  uploadHealthAnswersRevisionDocuments(
    archivedProposalId: string,
    healthAnswersRevisionId: string,
    documents: File[],
  ): Observable<ArchivedProposal> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) =>
        this.api.uploadHealthAnswersRevisionDocuments(
          session.id,
          archivedProposalId,
          healthAnswersRevisionId,
          documents,
        ),
      ),
    );
  }

  removeHealthAnswersRevisionDocuments(
    archivedProposalId: string,
    healthAnswersRevisionId: string,
    documentName: string,
  ): Observable<ArchivedProposal> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) =>
        this.api.removeHealthAnswersRevisionDocument(
          session.id,
          archivedProposalId,
          healthAnswersRevisionId,
          documentName,
        ),
      ),
    );
  }

  getHealthAnswersRevisionDocument(
    archivedProposalId: string,
    healthAnswersRevisionId: string,
    documentName: string,
  ): Observable<Blob> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) =>
        this.api.downloadHealthAnswersRevisionDocument(
          session.id,
          archivedProposalId,
          healthAnswersRevisionId,
          documentName,
        ),
      ),
    );
  }

  completeHealthAnswersRevisions(archivedProposalId: string, ids: string[]): Observable<ArchivedProposal> {
    return this.authService.currentAgentSessionOrAuthError.pipe(
      first(),
      mergeMap((session) => this.api.completeHealthAnswersRevisions(session.id, archivedProposalId, ids)),
    );
  }
}
